import { render, staticRenderFns } from "./AccountUncHistory.vue?vue&type=template&id=b1977048&"
import script from "./AccountUncHistory.vue?vue&type=script&lang=js&"
export * from "./AccountUncHistory.vue?vue&type=script&lang=js&"
import style0 from "./AccountUncHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports